interface IProductFunctionIconsTexts {
  [key: string]: {
    [key: string]: string
  }
}

const productFunctionIconsTexts: IProductFunctionIconsTexts = {
  DE: {
    '100prozent-alpaka': '100% Alpaka',
    '100prozent-baumwolle': '100% Baumwolle',
    '100prozent-kaschmir': '100% Kaschmir',
    '100prozent-merino': '100% Merino',
    '100prozent-wolle': '100% Wolle',
    '2-wege-reissverschluss': '2-Wege-Reissverschluss',
    '2-wege-stretch': '2-Wege-Stretch',
    '3-in-1': '3-In-1',
    '4-wege-stretch': '4-Wege-Stretch',
    allwettertauglich: 'Allwettertauglich',
    atmungsaktiv: 'Atmungsaktiv',
    'bei-leichter-inkontinenz': 'Bei Leichter Inkontinenz',
    'bei-mittlerer-inkontinenz': 'Bei Mittlerer Inkontinenz',
    'bei-starker-inkontinenz': 'Bei Starker Inkontinenz',
    buegelfrei: 'Bügelfrei',
    buegellos: 'Bügellos',
    'classic-form_carla': 'Classic Form Carla',
    'comfort-form-anna': 'Comfort Form Anna',
    'details-online': 'Details Online',
    doppelpack: 'Doppelpack',
    doppelverschluss: 'Doppelverschluss',
    echtleder: 'Echtleder',
    'empfehlenswert-bei-langem-sitzen': 'Empfehlenswert bei langem Sitzen',
    federleicht: 'Federleicht',
    feuchtigkeitsregulierend: 'Feuchtigkeitsregulierend',
    formbestaendig: 'Formbeständig',
    'fussspitze-handkettelt': 'Fußspitze Handkettelt',
    'gefuetterte-pads': 'Gefütterte Pads',
    'herausnehmbare-pads': 'Herausnehmbare Pads',
    'kapuze-abtrennbar': 'Kapuze Abtrennbar',
    'komfort-traeger-breite-traeger': 'Komfort Träger breite Träger',
    krempelbar: 'Krempelbar',
    'leicht-waermend': 'Leicht wärmend',
    mehrfachpack: 'Mehrfachpack',
    minimizer: 'Minimizer',
    'mit-alpaka': 'Mit Alpaka',
    'mit-baumwolle': 'Mit Baumwolle',
    'mit-biobaumwolle': 'Mit Biobaumwolle',
    'mit-buegel': 'Mit Bügel',
    'mit-kaschmir': 'Mit Kaschmir',
    'mit-merino': 'Mit Merino',
    'mit-recyceltem-rohstoff': 'Mit recyceltem Rohstoff',
    'mit-schurwolle': 'Mit Schurwolle',
    'mit-wolle': 'Mit Wolle',
    modal: 'Modal',
    nachhaltig: 'Nachhaltig',
    nahtlos: 'Nahtlos',
    'nicht-sichtbar': 'Nicht sichtbar',
    pflegeleicht: 'Pflegeleicht',
    reflektierend: 'Reflektierend',
    'rundum-dehnbund': 'Rundum Dehnbund',
    'schlupfbund-louisa': 'Schlupfbund Louisa',
    'schlupfbund-martha': 'Schlupfbund Martha',
    schlupfbund: 'Schlupfbund',
    schnelltrocknend: 'Schnelltrocknend',
    shaping: 'Shaping',
    'soft-touch': 'Soft Touch',
    'stark-waermend': 'Stark wärmend',
    'stuetzend-und-durchblutungsfoerdernd':
      'Stützend und durchblutungsfördernd',
    teildehnbund: 'Teildehnbund',
    thermo: 'Thermo',
    trocknergeeignet: 'Trocknergeeignet',
    twinset: 'Twinset',
    'uv-schutz': 'UV-Schutz',
    'verd-reissvers': 'Verdeckter Reißverschluss',
    'verstaerkte-bauchpartie': 'Verstärkte Bauchpartie',
    'verstellbare-traeger': 'Verstellbare Träger',
    viskose: 'Viskose',
    vorderverschluss: 'Vorderverschluss',
    waermend: 'Wärmend',
    waermeregulierend: 'Wärmeregulierend',
    waschmaschinengeeignet: 'Waschmaschinengeeignet',
    'wasser-abweisend': 'Wasserabweisend',
    wendejacke: 'Wendejacke',
    windabweisend: 'Windabweisend',
    'zusaetzliche-taschen': 'Zusätzliche Taschen',
    'zweiteiler-v1': 'Zweiteiler (V1)',
    'zweiteiler-v2': 'Zweiteiler (V2)',
    'fuer-jede-jahreszeit': 'Für Jede Jahreszeit',
  },
  FR: {
    '100prozent-alpaka': '100% alpaga',
    '100prozent-baumwolle': '100% coton',
    '100prozent-kaschmir': '100% cachemire',
    '100prozent-merino': '100% laine mérinos',
    '100prozent-wolle': '100% laine',
    '2-wege-reissverschluss': 'Fermeture par zip va-et-vient',
    '2-wege-stretch': 'Bi-extensible',
    '3-in-1': '3 en 1',
    '4-wege-stretch': 'Extensible dans tous les sens',
    allwettertauglich: 'Tout temps',
    atmungsaktiv: 'Respirant',
    'bei-leichter-inkontinenz': 'Pour incontinence légère',
    'bei-mittlerer-inkontinenz': 'Pour incontinence modérée',
    'bei-starker-inkontinenz': 'Pour incontinence forte',
    buegelfrei: 'Infroissable',
    buegellos: 'Sans armatures',
    'classic-form_carla': 'Coupe classique CARLA',
    'comfort-form-anna': 'Coupe confort ANNA',
    'details-online': 'Détails en ligne',
    doppelpack: 'Lot de 2',
    doppelverschluss: 'Double fermeture',
    echtleder: 'Cuir véritable',
    'empfehlenswert-bei-langem-sitzen':
      'Recommandé en cas de station assise prolongée',
    federleicht: 'Poids plume',
    feuchtigkeitsregulierend: "Régule l'humidité",
    formbestaendig: 'Indéformable',
    'fussspitze-handkettelt': 'Pointe du pied crocheté à la main',
    'gefuetterte-pads': 'Bonnets doublés',
    'herausnehmbare-pads': 'Bonnets amovibles',
    'kapuze-abtrennbar': 'Capuche amovible',
    'komfort-traeger-breite-traeger': 'Bretelles confort larges',
    krempelbar: 'Retroussable',
    'leicht-waermend': 'Chaleur modérée',
    mehrfachpack: 'Lot',
    minimizer: 'Minimiseur',
    'mit-alpaka': "Contient de l'alpaga",
    'mit-baumwolle': 'Contient du coton',
    'mit-biobaumwolle': 'Contient du coton bio',
    'mit-buegel': 'Avec armatures',
    'mit-kaschmir': 'Contient du cachemire',
    'mit-merino': 'Contient de la laine mérinos',
    'mit-recyceltem-rohstoff': 'Matérieux recyclés',
    'mit-schurwolle': 'Contient de la laine vierge',
    'mit-wolle': 'Contient de la laine',
    modal: 'Modal',
    nachhaltig: 'Durable',
    nahtlos: 'Sans coutures',
    'nicht-sichtbar': 'Invisible',
    pflegeleicht: 'Entretien facile',
    reflektierend: 'Réfléchissant',
    'rundum-dehnbund': 'Taille élastique',
    'schlupfbund-louisa': 'Pantalon LOUISA',
    'schlupfbund-martha': 'Pantalon MARTHA',
    schlupfbund: 'Pantalon à enfiler',
    schnelltrocknend: 'Vite sec',
    shaping: 'Modelant',
    'soft-touch': 'Soft touch',
    'stark-waermend': 'Chaleur élevée',
    'stuetzend-und-durchblutungsfoerdernd':
      'Protège et favorise la circulation sanguine',
    teildehnbund: 'Taille partiellement élastique',
    thermo: 'Thermo',
    trocknergeeignet: 'Adapté au sèche-linge',
    twinset: 'Twin-set',
    'uv-schutz': 'Protection UV',
    'verd-reissvers': 'Fermeture par zip inapparent',
    'verstaerkte-bauchpartie': 'Partie avant renforcée',
    'verstellbare-traeger': 'Bretelles réglables',
    viskose: 'Viscose',
    vorderverschluss: "Fermeture à l'avant",
    waermend: 'Bien chaud',
    waermeregulierend: 'Thermorégulateur',
    waschmaschinengeeignet: 'Adapté au lave-linge',
    'wasser-abweisend': 'Imperméable',
    wendejacke: 'Veste réversible',
    windabweisend: 'Coupe-vent',
    'zusaetzliche-taschen': 'Poches supplémentaires',
    'zweiteiler-v1': 'Ensemble deux pièces (V1)',
    'zweiteiler-v2': 'Ensemble deux pièces (V2)',
    'fuer-jede-jahreszeit': 'Toutes saisons',
  },
  NL: {
    '100prozent-alpaka': '100% alpaca',
    '100prozent-baumwolle': '100 % katoen',
    '100prozent-kaschmir': '100 % kasjmier',
    '100prozent-merino': '100% merinowol',
    '100prozent-wolle': '100 % wol',
    '2-wege-reissverschluss': '2-weg ritssluiting',
    '2-wege-stretch': '2-way stretch',
    '3-in-1': '3-in-1',
    '4-wege-stretch': '4-way stretch',
    allwettertauglich: 'voor alle weertypen',
    atmungsaktiv: 'actief ademend',
    'bei-leichter-inkontinenz': 'bij lichte incontinentie',
    'bei-mittlerer-inkontinenz': 'bij matige incontinentie',
    'bei-starker-inkontinenz': 'bij hevige incontinentie',
    buegelfrei: 'strijkvrij',
    buegellos: 'zonder beugels',
    'classic-form_carla': 'classic model carla',
    'comfort-form-anna': 'comfort model anna',
    'details-online': 'details online',
    doppelpack: 'set van twee',
    doppelverschluss: 'dubbele sluiting',
    echtleder: 'echt leer',
    'empfehlenswert-bei-langem-sitzen': 'aanbevolen bij langdurig zitten',
    federleicht: 'superlicht',
    feuchtigkeitsregulierend: 'vochtregulerend',
    formbestaendig: 'blijft mooi in model',
    'fussspitze-handkettelt': 'tenen met de hand aangehecht',
    'gefuetterte-pads': 'gevoerde cups',
    'herausnehmbare-pads': 'uitneembare cups',
    'kapuze-abtrennbar': 'afneembare capuchon',
    'komfort-traeger-breite-traeger': 'comfortabele brede bandjes',
    krempelbar: 'oprolbaar',
    'leicht-waermend': 'licht warm',
    mehrfachpack: 'set',
    minimizer: 'minimizer',
    'mit-alpaka': 'met alpaca',
    'mit-baumwolle': 'met katoen',
    'mit-biobaumwolle': 'met bio katoen',
    'mit-buegel': 'met beugels',
    'mit-kaschmir': 'met kasjmier',
    'mit-merino': 'met merinowol',
    'mit-recyceltem-rohstoff': 'met gerecycleerde grondstoffen',
    'mit-schurwolle': 'met scheerwol',
    'mit-wolle': 'met wol',
    modal: 'modal',
    nachhaltig: 'duurzaam',
    nahtlos: 'naadloos',
    'nicht-sichtbar': 'onzichtbaar',
    pflegeleicht: 'onderhoudsarm',
    reflektierend: 'reflecterend',
    'rundum-dehnbund': 'elastische tailleband',
    'schlupfbund-louisa': 'elastische tailleband louisa',
    'schlupfbund-martha': 'elastische tailleband martha',
    schlupfbund: 'elastische tailleband',
    schnelltrocknend: 'sneldrogend',
    shaping: 'modellerend',
    'soft-touch': 'superzacht',
    'stark-waermend': 'zeer warm',
    'stuetzend-und-durchblutungsfoerdernd':
      'ondersteunend en bevordert de bloedcirculatie',
    teildehnbund: 'deels elastische tailleband',
    thermo: 'thermo',
    trocknergeeignet: 'mag in de droger',
    twinset: 'twinset',
    'uv-schutz': 'uv bescherming',
    'verd-reissvers': 'blinde ritssluiting',
    'verstaerkte-bauchpartie': 'verstevigde buikwijdte',
    'verstellbare-traeger': 'verstelbare bandjes',
    viskose: 'viscose',
    vorderverschluss: 'voorsluiting',
    waermend: 'warm',
    waermeregulierend: 'warmteregulerend',
    waschmaschinengeeignet: 'mag in de wasmachine',
    'wasser-abweisend': 'waterafstotend',
    wendejacke: 'omkeerbaar jack',
    windabweisend: 'winddicht',
    'zusaetzliche-taschen': 'extra zakken',
    'zweiteiler-v1': 'tweedelig (V1)',
    'zweiteiler-v2': 'tweedelig (V2)',
    'fuer-jede-jahreszeit': 'voor elk jaargetijde',
  },
  FI: {
    '100prozent-alpaka': '100% alpakkaa',
    '100prozent-baumwolle': '100% puuvillaa',
    '100prozent-kaschmir': '100% kashmiria',
    '100prozent-merino': '100% villaa',
    '100prozent-wolle': '100% villaa',
    '2-wege-reissverschluss': 'kahteen suuntaan avautuva vetoketju',
    '2-wege-stretch': 'joustoa 2 suuntaan',
    '3-in-1': '3 yhdessä',
    '4-wege-stretch': 'joustoa 4 suuntaan',
    allwettertauglich: 'joka säähäven',
    atmungsaktiv: 'hengittävä',
    'bei-leichter-inkontinenz': 'kevyeen vuotoon',
    'bei-mittlerer-inkontinenz': 'kohtuulliseen vuotoon',
    'bei-starker-inkontinenz': 'viomakkaaseen vuotoon',
    buegelfrei: 'silittämättä siisti',
    buegellos: 'kaaritüton',
    'classic-form_carla': 'classic form carla',
    'comfort-form-anna': 'comfort olkaimet leveät olkaimet',
    'details-online': 'details online',
    doppelpack: 'tuplapakkaus',
    doppelverschluss: 'tuplakiinnitys',
    echtleder: 'aitoa nahkaa',
    'empfehlenswert-bei-langem-sitzen': 'pitkäkestoiseen istumiseen',
    federleicht: 'höyhenenkevyt',
    feuchtigkeitsregulierend: 'kosteutta säätelevä',
    formbestaendig: 'muotonsa säilyttävä',
    'fussspitze-handkettelt': 'käsin ketlattu kärkisauma',
    'gefuetterte-pads': 'vuorilliset kupit',
    'herausnehmbare-pads': 'irrotettavat pehmusteet',
    'kapuze-abtrennbar': 'irrotettava huppu',
    'komfort-traeger-breite-traeger': 'comfort olkaimet leveät olkaimet',
    krempelbar: 'käärittävät',
    'leicht-waermend': 'kevyesti lämmittävä',
    mehrfachpack: 'monipakkaus',
    minimizer: 'minimizer malli',
    'mit-alpaka': 'sisältää alpakkaa',
    'mit-baumwolle': 'sisiältää puuvillaa',
    'mit-biobaumwolle': 'Luomupuuvillaa',
    'mit-buegel': 'kaaritülliset',
    'mit-kaschmir': 'sisältää kashmiria',
    'mit-merino': 'sisältää merinovillaa',
    'mit-recyceltem-rohstoff': 'kierrätettyä materiaalia',
    'mit-schurwolle': 'sisältää uutta villaa',
    'mit-wolle': 'sisältää villaa',
    modal: 'modaalia',
    nachhaltig: 'kestävää kehitystä',
    nahtlos: 'saumaton',
    'nicht-sichtbar': 'huomaamaton',
    pflegeleicht: 'helppohoitoinen',
    reflektierend: 'heijastava',
    'rundum-dehnbund': 'joustovyötärö',
    'schlupfbund-louisa': 'joustovyötärö louisa',
    'schlupfbund-martha': 'joustovyötärö martha',
    schlupfbund: 'joustovyötärö',
    schnelltrocknend: 'nopeasti kuivuva',
    shaping: 'muokkaava',
    'soft-touch': 'pehmeä tuntu',
    'stark-waermend': 'vahvasti lämmittävä',
    'stuetzend-und-durchblutungsfoerdernd': 'tukeva ja verenkiertoa parantava',
    teildehnbund: 'osin joustava vyötärö',
    thermo: 'lämpöominaisuus',
    trocknergeeignet: 'kestää rumpukuivauksen',
    twinset: 'twinset',
    'uv-schutz': 'uv suoja',
    'verd-reissvers': 'Piilotettu vetoketju',
    'verstaerkte-bauchpartie': 'Vahvistettu vatsaosa',
    'verstellbare-traeger': 'säädettävät olkaimet',
    viskose: 'viskoosia',
    vorderverschluss: 'kiinnitys edessä',
    waermend: 'lämmittävä',
    waermeregulierend: 'lämpöä säätelvä',
    waschmaschinengeeignet: 'konepestävä',
    'wasser-abweisend': 'vettähylkivä',
    wendejacke: 'kääntötakki',
    windabweisend: 'tuulenpitävä',
    'zusaetzliche-taschen': 'lisä taskut',
    'zweiteiler-v1': 'kaksiosainen (V1)',
    'zweiteiler-v2': 'kaksiosainen (V2)',
    'fuer-jede-jahreszeit': 'joka vuodenaikaan',
  },
}

export default productFunctionIconsTexts
